import { tss } from 'tss-react';
import Button from "@mui/material/Button";
import React, { useState, useEffect } from "react";

import styles from "./styles";
import _ from "lodash";

import Link from "@mui/material/Link";
import WebsaUITheme from '../Shared/WebsaUITheme';
import ThemeProvider from '../Shared/ThemeProvider';

import RailsForm from '../Shared/RailsForm';
import RailsRoutes from '../Shared/RailsRoutes';
import Copyright from "../Shared/Copyright/Copyright";

import AuthCode from "react-auth-code-input";
import QRCode from "react-qr-code";
import LogoHeader from "../Shared/LogoHeader/LogoHeader";
import Slider from "../Shared/Slider/Slider";

export default function TwoFASetup(props) {
  const theme = ThemeProvider(props.theme);
  const { classes, cx } = tss.create(styles(theme))();

  const [twoFA, setTwoFA] = useState();
  const [error, setError] = useState(props.flash && props.flash.alert);

  const formAttrs = {
    action: RailsRoutes.user_two_factor_authentication_path(),
    autoComplete: 'off',
    method: 'POST',
    className: classes.tagForm
  }

  useEffect(() => {
    if (twoFA) setError(null);
  }, [twoFA]);

  return (
    <WebsaUITheme theme={props.theme}>
      <div className={classes.root}>
        <LogoHeader/>
        <div className={classes.slider}>
          <Slider/>
        </div>
        <div className={classes.form}>
          <div className={classes.head}>
            <p>
              Sign in as a different user? <Link rel="stylesheet" data-method="DELETE" href={RailsRoutes.destroy_user_session_path()}>Sign out</Link>
            </p>
          </div>
          <RailsForm attrs={formAttrs}>
            <div className={classes.root}>
              <div className={classes.loginForm}>
                <h3 className={classes.infoBlockTitle}>
                  New 2FA setup required
                  <p className={classes.infoBlockDescription}>
                    Security settings have been updated.
                  </p>
                  <p className={classes.infoBlockDescription}>
                    Please scan the QR code below with your 2FA application and enter the code to verify.
                  </p>
                  <QRCode size={184} value={props.totp_url}/>
                </h3>

                <AuthCode
                  allowedCharacters="numeric"
                  containerClassName={classes.otpContainer}
                  inputClassName={cx(classes.otpInput, error && classes.otpError)}
                  onChange={setTwoFA}
                />
                <p className={classes.otpErrorText}>
                  {error}&nbsp;
                </p>
                <input type="hidden" name="secret" value={props.totp_secret} />
                <input type="hidden" name="code" value={twoFA}/>
                <Button
                  variant="contained"
                  type="submit"
                  onClick={e => e.currentTarget.form.submit()}
                  color="primary"
                  className={classes.otpButton}
                  disabled={_.size(twoFA) !== 6}>
                  Verify code
                </Button>
              </div>
            </div>
          </RailsForm>
          <Copyright/>
        </div>
      </div>
    </WebsaUITheme>
  );
}
